import { render, staticRenderFns } from "./common-center-dialog.vue?vue&type=template&id=f53d4a40&scoped=true&"
import script from "./common-center-dialog.vue?vue&type=script&lang=js&"
export * from "./common-center-dialog.vue?vue&type=script&lang=js&"
import style0 from "./common-center-dialog.vue?vue&type=style&index=0&id=f53d4a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53d4a40",
  null
  
)

export default component.exports